var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C9.59112 0 10.9025 1.25681 10.9941 2.82422L10.999 2.99902V4.99902C10.999 5.60112 10.8274 6.47417 10.5264 7.19531C10.3524 7.61202 10.2223 8.00072 9.50098 8.625C8.38628 9.47723 7.6671 10.821 7.66699 12.333C7.66699 13.8208 8.36284 15.1464 9.44727 16.001L0 16L0.489258 12.9951C0.509871 12.8739 0.598845 12.73 0.702148 12.6426L0.765625 12.5977L5.38086 9.91992C5.48213 9.86173 5.59655 9.74005 5.66504 9.62305L5.70703 9.53711L6.25 8.32129C5.52975 7.81073 5.0606 6.21316 5.00781 5.18652L5.00293 5.00098V3.00098C5.00293 1.35152 6.3514 1.30282e-07 8 0ZM12.333 8.66699C14.3579 8.66699 15.9998 10.3081 16 12.333C16 14.3581 14.3581 16 12.333 16C10.3081 15.9998 8.66699 14.3579 8.66699 12.333C8.66717 10.3082 10.3082 8.66717 12.333 8.66699ZM12.333 10C12.057 10.0002 11.833 10.224 11.833 10.5V11.833H10.5C10.224 11.833 10.0002 12.057 10 12.333C10 12.6091 10.2239 12.833 10.5 12.833H11.833V14.167C11.8332 14.4429 12.0571 14.6668 12.333 14.667C12.609 14.667 12.8328 14.443 12.833 14.167V12.833H14.167C14.443 12.8328 14.667 12.609 14.667 12.333C14.6668 12.0571 14.4429 11.8332 14.167 11.833H12.833V10.5C12.833 10.2239 12.6091 10 12.333 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCheck);
export default __webpack_public_path__ + "static/media/new-check.bc7f69cebde6246eefe2a4596b47396e.svg";
export { ForwardRef as ReactComponent };